import jQuery from "jquery";

export default class Navigation {
  constructor(id) {
    if (!id) {
      return;
    }

    this.collapse = jQuery(id);
    this.scrollPosition = 0;

    if (!this.collapse) {
      return;
    }

    this.events();
  }

  /**
   * Bootstrap 4.* events to trigger accassibility logics
   */
  events() {
    this.collapse

      // This event fires immediately when the show instance method is called.
      .on("show.bs.collapse", (e) => {
        this.scrollPosition = window.scrollY;
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.classList.add("menu-active");

        this.setTabIndex(e.target.getElementsByTagName("A"), 0);

        // Set tabindex of all focusable elements outside of menu to -1
        const focusableElements =
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)';

        const main = document.querySelector("#main");
        if (main) {
          this.setTabIndex(
            document.querySelector("#main").querySelectorAll(focusableElements),
            -1,
          );
        }

        const footer = document.querySelector("#footer");
        if (footer) {
          this.setTabIndex(footer.querySelectorAll(focusableElements), -1);
        }

        this.setTabIndex(
          document.querySelectorAll("body > a", "body > button", ".logo a"),
          -1,
        );
      })
      // This event is fired immediately when the hide method has been called.
      .on("hide.bs.collapse", (e) => {
        document.body.classList.remove("menu-active");
        document.body.style.top = null;
        document.documentElement.style.scrollBehavior = "auto";
        window.scrollTo(0, this.scrollPosition);
        document.documentElement.style.scrollBehavior = "smooth";

        this.setTabIndex(e.target.getElementsByTagName("A"), -1);

        // Set tabindex of all focusable elements outside of menu to -1
        const focusableElements =
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)';

        const main = document.querySelector("#main");
        if (main) {
          this.setTabIndex(
            document.querySelector("#main").querySelectorAll(focusableElements),
            0,
          );
        }

        const footer = document.querySelector("#footer");
        if (footer) {
          this.setTabIndex(footer.querySelectorAll(focusableElements), 0);
        }

        this.setTabIndex(
          document.querySelectorAll("body > a", "body > button", ".logo a"),
          0,
        );
      })

      // This event is fired when a collapse element has been hidden from the user (will wait for CSS transitions to complete).
      .on("hidden.bs.collapse", (e) => {
        this.setTabIndex(e.target.getElementsByTagName("A"), -1);

        // Set tabindex of all focusable elements outside of menu to -1
        const focusableElements =
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)';

        const main = document.querySelector("#main");
        if (main) {
          this.setTabIndex(
            document.querySelector("#main").querySelectorAll(focusableElements),
            0,
          );
        }

        const footer = document.querySelector("#footer");
        if (footer) {
          this.setTabIndex(footer.querySelectorAll(focusableElements), 0);
        }

        this.setTabIndex(
          document.querySelectorAll("body > a", "body > button", ".logo a"),
          0,
        );
      });
  }

  /**
   * Set link tabindexes to the given value
   * @param links
   * @param enable
   */
  setTabIndex(links, enable = 0) {
    [...links].forEach((el) => el.setAttribute("tabindex", enable));
  }
}
